var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_121_5747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H27C30.866 0 34 3.13401 34 7V33C34 33.5523 33.5523 34 33 34H7C3.13401 34 0 30.866 0 27V7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H27C30.866 0 34 3.13401 34 7V33C34 33.5523 33.5523 34 33 34H7C3.13401 34 0 30.866 0 27V7Z",
    stroke: "#130F26",
    strokeWidth: 7,
    mask: "url(#path-1-inside-1_121_5747)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_121_5747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 7C80 3.13401 76.866 0 73 0H53C49.134 0 46 3.13401 46 7V33C46 33.5523 46.4477 34 47 34H73C76.866 34 80 30.866 80 27V7Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7C80 3.13401 76.866 0 73 0H53C49.134 0 46 3.13401 46 7V33C46 33.5523 46.4477 34 47 34H73C76.866 34 80 30.866 80 27V7Z",
    stroke: "#130F26",
    strokeWidth: 7,
    mask: "url(#path-2-inside-2_121_5747)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_121_5747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 72C80 75.866 76.866 79 73 79H53C49.134 79 46 75.866 46 72V46C46 45.4477 46.4477 45 47 45H73C76.866 45 80 48.134 80 52V72Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72C80 75.866 76.866 79 73 79H53C49.134 79 46 75.866 46 72V46C46 45.4477 46.4477 45 47 45H73C76.866 45 80 48.134 80 52V72Z",
    stroke: "#130F26",
    strokeWidth: 7,
    mask: "url(#path-3-inside-3_121_5747)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_121_5747",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 72C0 75.866 3.13401 79 7 79H27C30.866 79 34 75.866 34 72V46C34 45.4477 33.5523 45 33 45H7C3.13401 45 0 48.134 0 52V72Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 72C0 75.866 3.13401 79 7 79H27C30.866 79 34 75.866 34 72V46C34 45.4477 33.5523 45 33 45H7C3.13401 45 0 48.134 0 52V72Z",
    stroke: "#130F26",
    strokeWidth: 7,
    mask: "url(#path-4-inside-4_121_5747)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.15e0960f628151315c44067bd4a0d417.svg";
export { ForwardRef as ReactComponent };